<template>
  <div class="product-filters__select-wrapper select">
    <label for="safetyClassifications" class="label">Säkerhetsklassning</label>
      <select
        id="safetyClassifications"
        class="select__select"
        v-model="selected"
      >
        <option value="0" disabled>Välj...</option>
        <option
          v-for="option in options"
          v-bind:key="option.id"
          :value="option.id"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
</template>

<script>

import Vue from 'vue'
import Component from "vue-class-component"
import { Prop } from 'vue-property-decorator'

//
@Component({
})
export default class SafetyClassification extends Vue {
  @Prop() options;
  selected = 0;

  created() {
    // console.log('SafetyClassification created');
  }

  mounted() {
    this.selected = this.setSelect();
  }

  updated() {
    const defaultOption = this.options.find(item => item.selected);
    if (!defaultOption.id) { return; }
    if (this.selected !== defaultOption.id.toString()) {
      // console.log('SafetyClassification updated')
      const selectedOption = this.options.find(item => item.id === this.selected);
      !!selectedOption.path && window.location.assign(selectedOption.path);
    }
  }

  setSelect () {
    if (!!this.options) {
      const defaultOption = this.options.find(item => item.selected);
      return !defaultOption?.id ? 0 : defaultOption.id.toString();
    }

  }

}
</script>

<style>

</style>
